import React from "react";
import { useI18n } from "@/context/I18nContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, t } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium border border-slate-200 rounded-md bg-white hover:bg-slate-50 transition-colors"
      >
        <Globe className="w-4 h-4" />
        <span className="uppercase tracking-wider">{lang}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        <DropdownMenuItem
          data-testid="lang-option-el"
          onClick={() => setLang("el")}
          className={lang === "el" ? "font-semibold" : ""}
        >
          🇬🇷 Ελληνικά
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="lang-option-en"
          onClick={() => setLang("en")}
          className={lang === "en" ? "font-semibold" : ""}
        >
          🇬🇧 English
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
